import { useSelector, shallowEqual } from 'react-redux'

import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'
import { Allowance } from './useReportAllowances'


export type AllSchoolsAllowancesDto = Array<{
  school_title: string
  data: {
    personal: number
    common: number
    total: number
    allowances: Record<Allowance, number>
  }
}>

export function useReportAllSchoolsAllowancesDto() {
  const allSchools = useSelector((state: any) => state.reports.subsidies.data.all_schools, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  if (allSchools && detailsGroup === DetailsGroup.ByAllowances) {
    return allSchools as AllSchoolsAllowancesDto
  }
  return null
}
